import { PERIODS } from '@/modules/usage/constants/countables';

const toRow = (balance) => ({
  key: balance.subscription_uid,
  period: balance.period,
  unlimited: balance.unlimited === true,
  consumed: balance.consumed ?? 0,
  credit: balance.credit ?? null,
  left: balance.left ?? null,
  resetsAt: balance.resets_at || null,
  expiresAt: balance.expires_at || null,
});

const MONTHLY_FIRST = (a, b) => {
  if (a.period === b.period) return 0;
  return a.period === PERIODS.MONTHLY ? -1 : 1;
};

export const groupBySku = (balances = []) => balances.reduce((acc, balance) => {
  if (!balance?.sku) return acc;
  acc[balance.sku] = acc[balance.sku] || [];
  acc[balance.sku].push(toRow(balance));
  acc[balance.sku].sort(MONTHLY_FIRST);
  return acc;
}, {});

export default { groupBySku };
